import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders } from '../headers';

import {
  USER_FIND_REQUESTED,
  USER_FIND_SUCCESS,
  USER_FIND_FAILURE,
  USERS_INDEX_REQUESTED,
  USERS_INDEX_SUCCESS,
  USERS_INDEX_FAILURE,
  USER_CREATE_REQUESTED,
  USER_CREATE_SUCCESS,
  USER_CREATE_FAILURE,
  USER_DELETE_REQUESTED,
  USER_DELETE_SUCCESS,
  USER_DELETE_FAILURE,
  USER_UPDATE_REQUESTED,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAILURE,

} from '../types';

export const userRequested = () => {
  return {
    type: USER_FIND_REQUESTED
  }
};

export const userSuccess = (user) => {
  return {
    type: USER_FIND_SUCCESS,
    payload: user
  }
};

export const userFailure = () => {
  return {
    type: USER_FIND_FAILURE
  }
};


export const usersIndexRequested = () => {
  return {
    type: USERS_INDEX_REQUESTED
  }
}


export const usersIndexSuccess = (users) => {
  return {
    type: USERS_INDEX_SUCCESS,
    payload: users
  }
}

export const userCreateRequested = () => {
  return {
    type: USER_CREATE_REQUESTED
  }
}


export const userCreateSuccess = (user) => {
  return {
    type: USER_CREATE_SUCCESS,
    payload: user
  }
}

export const userCreateFailure = () => {
  return {
    type: USER_CREATE_FAILURE
  }
}


export const userDeleteRequested = (email) => {
  return {
    type: USER_DELETE_REQUESTED,
    email: email
  }
}


export const userDeleteSuccess = (email) => {
  return {
    type: USER_DELETE_SUCCESS,
    payload: email
  }
}

export const userDeleteFailure = () => {
  return {
    type: USER_DELETE_FAILURE
  }
}

export const userUpdateRequested = (email) => {
  return {
    type: USER_UPDATE_REQUESTED,
    email: email
  }
}


export const userUpdateSuccess = (user) => {
  return {
    type: USER_UPDATE_SUCCESS,
    payload: user
  }
}

export const userUpdateFailure = () => {
  return {
    type: USER_UPDATE_FAILURE
  }
}


export const getCurrentUser = () => {
  return async (dispatch) => {
    dispatch(userRequested());

    const endPoint = Config.baseUrl + Config.user;
    const headers = await authHeaders();

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(userSuccess(response.data));
      })
  }
}

export const getAllUsers = () => {
  return async (dispatch) => {
    dispatch(usersIndexRequested());

    const endPoint = Config.baseUrl + Config.users;
    const headers = await authHeaders();

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(usersIndexSuccess(response.data));
      })

  }
}

export const userCreate = (user) => {
  return async (dispatch) => {
    dispatch(userCreateRequested());

    const endPoint = Config.baseUrl + Config.user;
    const headers = await authHeaders();

    return Axios.post(endPoint, { user: user }, { headers: headers })
      .then((response) => {
        dispatch(userCreateSuccess(response.data));
      })
      .catch((error) => {
        console.log(error);

        dispatch(userCreateFailure());
      });
  }
}

export const userDelete = (email) => {
  return async (dispatch) => {
    dispatch(userDeleteRequested(email));

    const endPoint = Config.baseUrl + Config.user + email;
    const headers = await authHeaders();

    return Axios.delete(endPoint, { headers: headers })
      .then(() => {
        dispatch(userDeleteSuccess(email));
      })
      .catch(() => {
        dispatch(userDeleteFailure());
      });

  }
}

export const userUpdate = (user) => {
  return async (dispatch) => {
    dispatch(userUpdateRequested(user.email));

    const endPoint = Config.baseUrl + Config.user;
    const headers = await authHeaders();

    return Axios.put(endPoint, user, { headers: headers })
      .then((response) => {
        dispatch(userUpdateSuccess(response.data));
      })
      .catch(() => {
        dispatch(userUpdateFailure());
      });

  }
}
